/* eslint-disable no-async-promise-executor */
/* eslint-disable react/no-deprecated */
import { ActiveContext } from 'contexts/legacy/ActiveContext';
import React from 'react';
import ReactGA from 'react-ga';
import { active } from 'services/active';

const tagMap = {
  0: '153', // api_whatsapp_instalado
  1: '',
  2: '',
  3: '',
  4: '145', // api_whatsapp_canal_aberto_configurado
  api_whatsapp_enviou_a_primeira_mensagem: '142', // api_whatsapp_enviou_a_primeira_mensagem
  api_whatsapp_finalizou_instalacao: '18727',
  twilio: '136',
  zapbox: '452',
  messageBird: '18726',
  renew: '144',
};

// const listSq2Id = 2;

class ActiveProvider extends React.Component {
  state = {
    enable_active: true,
    user: {
      EMAIL: 'matheus.bento33334243@br24.pro',
      NAME: 'Matheus',
      PERSONAL_PHONE: '',
    },
    onbitrix: false,
    domain: '',
    placement: null,
    isAdmin: false,
    loadingChannels: true,
    infos: {
      domain: '',
      auth: '',
    },
    loaded: false,
    auth: {},
    createCustomer: this.createCustomer.bind(this),
    ReactGA: {},
    sendEventGA: this.sendEventGA.bind(this),
  };

  async UNSAFE_componentWillMount() {
    try {
      window.BX24.init(async () => {
        const auth = window.BX24
          ? window.BX24.getAuth()
          : { domain: 'solinka.bitrix24.com' };
        this.setState({ auth });
        const domain = auth.domain;
        const lang = window.BX24 ? window.BX24.getLang() : 'en';
        // const profile = window.BX24 ? window.BX24.profile() : {
        //     name: "",
        //     email: "",
        // };

        this.setState({ domain });
        this.setState({ lang });
        // this.setState({ profile });

        await window.BX24.callMethod('user.current', {}, async (res) => {
          let user = res.data();

          user = user || {
            NAME: '',
            EMAIL: '',
            PERSONAL_PHONE: '',
          };

          const stado = {
            onbitrix: true,
            onbitrixFunction: true,
            user,
            placement: window.BX24.placement.info(),
            isAdmin: window.BX24.isAdmin(),
            loaded: true,
          };

          this.setState(stado);

          window.BX24.fitWindow();
        });
      });
    } catch (e) {
      console.log('ActiveProvider::UNSAFE_componentWillMount', {
        Exception: e,
      });
      this.setState({ onbitrix: false, onbitrixFunction: false });
    }
  }

  // getContactByEmail() {
  //     return new Promise(async (resolve, reject) => {
  //         this.setState({ loadingContact: true });
  //         var request = {
  //             params: {
  //                 email: this.state.user.EMAIL
  //             }
  //         };

  //         await active.get("contacts", request).then(res => {
  //             this.setState({ loadingContact: false });
  //             if (res.data.contacts.length == 0) {
  //                 resolve(null);
  //             } else {
  //                 resolve(res.data.contacts[0].id);
  //             }
  //         });
  //     });
  // }

  sendEventGA(action) {
    return new Promise(async (resolve) => {
      if (this.state.loaded) {
        const GA_ID = 'UA-42943143-37';
        ReactGA.initialize(GA_ID, {
          debug: false,
          titleCase: false,
        });
        ReactGA.set({
          userId: this.state.domain,
        });
        // ReactGA.pageview(window.location.pathname + window.location.search);
        // this.setState({ ReactGA });
        const event = {
          category: 'engagement',
          action,
          label: this.state.domain,
          // nonInteraction: true
        };
        const result = ReactGA.event(event);

        resolve(result);
      }
    });
  }

  // updateContactList(contact_id) {
  //     return new Promise(async (resolve, reject) => {
  //         this.setState({ loadingContact: true });
  //         var request = {
  //             contactList: {
  //                 contact: contact_id,
  //                 list: listSq2Id,
  //                 status: 1
  //             }
  //         };

  //         await active.post("contactLists", request).then(res => {
  //             this.setState({ loadingContact: false });
  //             if (res.data.length == 0) {
  //                 reject(res.data);
  //             } else {

  //                 resolve(res.data.contacts[0].id);

  //             }
  //         });
  //     });
  // }

  // gus - Ignore o nome desse método pois o mesmo não faz sentido.
  // A função registra as tags no Active Campaign para o portal do bitrix onde o app está instalado.
  createCustomer(tag) {
    return new Promise(async (resolve, reject) => {
      const request = {
        // contact: {
        action: 'setActive',
        domain: this.state.domain,
        customer_name: this.state.user.NAME,
        customer_email: this.state.user.EMAIL,
        customer_phone: this.state.user.PERSONAL_PHONE,
        customer_lang: window.BX24.getLang(),
        tag: tagMap[tag],
        // }
      };

      await active.post('setActive', request).then((res) => {
        this.setState({ loadingContact: false });
        if (!res.data.status) {
          reject(res.data);
        } else {
          resolve(res.data);
        }
      });
    });
  }

  render() {
    return (
      <ActiveContext.Provider value={this.state}>
        {this.props.children}
      </ActiveContext.Provider>
    );
  }
}

export default ActiveProvider;
